import { Button } from "react-bootstrap";
import clsx from "classnames";
import PropTypes from "prop-types";
import classes from "./styles.module.scss";
import ArrowRight from "@/assets/ArrowRight.svg";
import { ensureTrailingSlash } from '@/functions/ensureTrailingSlash';

export default function CTA({ className, label, href, target, variant }) {
  return (
    <div className={clsx(className, classes.cta)}>
      <Button variant={variant} href={ensureTrailingSlash(href)} target={target}>
        {label}
        <ArrowRight />
      </Button>
    </div>
  );
}

CTA.defaultProps = {
  className: "",
  label: "",
  href: "",
  target: "_self",
  variant: "dark",
};

CTA.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  variant: PropTypes.string,
};
